import React from "react";
import { ThemeProvider } from "styled-components";
import theme from "onnit-ui/lib/themes/light";
import Box from "onnit-ui/lib/box/Box";
import useOnnitContext from "onnit-ui/lib/hooks/useOnnitContext";
import config from "../../config/config";
import { TwelveColumn } from "onnit-ui/lib/module/grid/12/Grid";
import GlobalStyle from "onnit-ui/lib/themes/GlobalStyle";
import { BgImage, Img } from "onnit-ui/lib/image";
import usePageData from "../../hooks/usePageData";
import Trials from "./shared/Trials";

function Page() {

    //get window.onnit_context for image urls etc.
    const onnitContext = useOnnitContext();
    const { pageData } = usePageData();


    if (!pageData || !onnitContext) return null;

    const IMG_URL = onnitContext.url.cdn.static_images;
    const PAGE_IMG_URL = IMG_URL + "/landers/choose-your-trial";

    const { IMG_PARAMS } = config;

    return (
        <ThemeProvider theme={theme}>
            <GlobalStyle />
            <Box maxWidth="1920px" mx="auto">
                <TwelveColumn>
                    <BgImage
                        gridColumn={"1 / -1"}
                        width="100%"
                        lazy={false}
                        src={`${PAGE_IMG_URL}/2023-Free-Trial-Update-WPage-header.png${IMG_PARAMS})`}
                    >
                        <Box
                            gridColumn={["1 / -1", "1 / -1", "1 / -1", "5 / span 4"]}
                        >
                            <Box width={["75%"]} mx="auto" py={7}>
                                <Img
                                    placeholder={[460, 280]}
                                    mx="auto"
                                    alt="Free Trial."
                                    style={{ maxWidth: "543px", maxHeight: "227px" }}
                                    src={`${PAGE_IMG_URL}/2023-Free-Trial-Update-WPage-logo.svg${IMG_PARAMS})`}
                                />
                            </Box>
                        </Box>
                    </BgImage>
                </TwelveColumn>
                <Box px={[6, 6, 0, 0]} pb={4}>
                    <Trials imgUrl={IMG_URL} pageImgUrl={PAGE_IMG_URL} imgParams={IMG_PARAMS} />
                </Box>
            </Box>
        </ThemeProvider>
    )
        ;
}

export default Page;
